module.exports = __webpack_public_path__ + "img/attraction-3-old.2907187d.jpg";